// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"097d9528","995":"097d9528"}[chunkId] + ".chunk.css";
};